import { FormattedMessage } from 'react-intl';

import { Button } from '@/ui/Button/Button';
import { Flex } from '@/ui/Flex/Flex';
import { Modal } from '@/ui/Modal/Modal';

export type SaveChangesModalProps = {
  readonly open: boolean;
  readonly isSaving: boolean;
  readonly onReturnToEditing: () => void;
  readonly onDoNotSave: () => void;
  readonly onSave: () => void;
};

export const SaveChangesModal = ({
  open,
  isSaving,
  onReturnToEditing,
  onDoNotSave,
  onSave,
}: SaveChangesModalProps) =>
  open ? (
    <Modal
      footer={
        <Flex gap={16} grow justify="flex-end" padding={32}>
          <Button
            disabled={isSaving}
            mode="link"
            onClick={() => onReturnToEditing?.()}
            size="large"
          >
            <FormattedMessage defaultMessage="Return to editing" id="uQVmjH" />
          </Button>
          <Button
            disabled={isSaving}
            mode="link"
            onClick={() => onDoNotSave?.()}
            size="large"
          >
            <FormattedMessage defaultMessage="Do not save" id="RsDY2d" />
          </Button>
          <Button
            loading={isSaving}
            onClick={async () => onSave()}
            size="large"
          >
            <FormattedMessage defaultMessage="Save changes" id="X0ha1a" />
          </Button>
        </Flex>
      }
      title="Unsaved changes"
    >
      <div>
        <FormattedMessage
          defaultMessage=" You have open unsaved changes, please save or discard these changes before leaving this page"
          id="4tSKqU"
        />
      </div>
    </Modal>
  ) : null;
